import { Box, Flex, Text } from '@chakra-ui/react';
import { HeaderCard } from './components/HeaderCard';
import { RoundedNumber } from './components/RoundedNumber';
import { BsBell } from 'react-icons/bs';
import { Card } from './components/Card';

export function NovosChamados({ infoCustomer, codCustomerSelected, isLoading }) {
  return (
    <Box w="513px">
      <HeaderCard title="Chamados" icon={<BsBell size={24} color="#2D2D2D" />} />

      <Card
        mt={2}
        py={'9px'}
        display="flex"
        alignItems="center"
        justifyContent="space-around"
        isLoading={isLoading}>
        <Flex flexDir="column" gap={2} alignItems="center" justifyContent="center">
          <Text fontSize="12px" textTransform="uppercase" fontWeight="semibold" color="#2D2D2D">
            Novos chamados
          </Text>

          <RoundedNumber
            number={infoCustomer?.novos_chamados}
            bgColor="#95C620"
            to={`/propostas/${codCustomerSelected}?novos_chamados=true`}
          />
        </Flex>
        <Flex flexDir="column" gap={2} alignItems="center" justifyContent="center">
          <Text fontSize="12px" textTransform="uppercase" fontWeight="semibold" color="#2D2D2D">
            Meus chamados
          </Text>

          <RoundedNumber
            number={infoCustomer?.meus_chamados}
            bgColor="#378BBF"
            to={`/propostas/${codCustomerSelected}?meus_chamados=true`}
          />
        </Flex>
      </Card>
    </Box>
  );
}
